'use client'

import React from 'react'

import { HeroChatLauncherSlot } from '@/components/Hero/HeroChatLauncherSlot'
import { PageHero } from '@/components/Hero/PageHero'
import { HeroMediaOverlay } from '@/components/Hero/HeroMediaOverlay'
import {
  PAGE_HERO_FULL_VIEWPORT_PULLED_CLASS_NAME,
  pageHeroPulledVideoControlClassName,
} from '@/components/Hero/pageHeroLayout'
import { useHeroStickyBannerClearance } from '@/components/Hero/useHeroStickyBannerClearance'
import {
  HeroVideoLayer,
  HeroVideoPlaybackButton,
  useHeroVideoBackground,
} from '@/components/Hero/HeroVideoBackground'
import {
  LANDING_HERO_FALLBACK_IMAGE,
  type ResolvedHeroBackground,
} from '@/lib/hero/resolveHeroBackgroundMedia'

type LandingHeroProps = {
  background?: ResolvedHeroBackground
}

export const LandingHero: React.FC<LandingHeroProps> = ({ background }) => {
  const resolved = background ?? {
    imageSrc: LANDING_HERO_FALLBACK_IMAGE,
    imageAlt: '',
  }

  const heroVideo = useHeroVideoBackground({
    desktopSrc: resolved.desktopVideoSrc,
    mobileSrc: resolved.mobileVideoSrc,
    poster: resolved.imageSrc,
    posterAlt: resolved.imageAlt,
  })
  const { compact, contentClassName } = useHeroStickyBannerClearance('landing-pulled')

  return (
    <PageHero
      aria-label="Welcome"
      background={
        <>
          <HeroVideoLayer video={heroVideo} />
          <HeroMediaOverlay tone="landing" />
        </>
      }
      className={`z-10 max-w-full ${PAGE_HERO_FULL_VIEWPORT_PULLED_CLASS_NAME}`}
      contentClassName={contentClassName}
      gradientClassName={false}
      heightMode="viewport"
      pullUnderHeader
    >
      <HeroVideoPlaybackButton
        className={pageHeroPulledVideoControlClassName}
        video={heroVideo}
      />

      <HeroChatLauncherSlot active={!compact} />

      <h1
        className="mb-0 max-w-full text-balance text-hero-title text-white drop-shadow-[0_16px_32px_-8px_rgba(12,12,13,0.4)] md:mb-4 md:max-w-3xl lg:max-w-4xl"
        lang="en"
      >
        <span className="block">Experience the Future of Student Housing</span>
      </h1>
    </PageHero>
  )
}
